<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table"><slot></slot></h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div class="ly-sort ly-sort-his">
      <span class="count">
        <p class="table-cell-all">
          {{ $t("messages.all") }} <span class="table-cell-count">97</span
          >{{ $t("messages.unit") }}
        </p>
      </span>
    </div>
    <div ref="content">
      <div class="content">
        <idc-list :tableHeader="tableHeader" :tableData="tableData">
          <template #sftyChkDay="{ scope }">
            <el-date-picker
              v-model="scope.row.sftyChkDay"
              size="mini"
              type="date"
              align="right"
              placeholder="YYYY/MM/DD"
              value-format="yyyy/MM/dd"
              disabled
            />
          </template>
          <template #sftyChkSbst="{ scope }">
            <el-input
              :placeholder="$t('messages.plInput')"
              v-model="scope.row.sftyChkSbst"
              size="small"
              disabled
            >
            </el-input>
          </template>
          <template #chkTxnFile="{ scope }">
            <div class="border-box">
              <template v-for="file in scope.row.chkTxnFile.preFileList">
                  <div class="border-box" :key="file.atcFileSeq">
                    <idc-file-upload :file-list="[file]"
                      :on-remove="removePreFile"
                      :on-preview="downloadFile"
                    ></idc-file-upload>
                    <!-- <el-button size="small" type="minus" @click="removePreFile(file,scope.$index)"><i class="icon-Minus"/></el-button> -->
                  </div>
                </template>
            </div>
            <!-- <div
              class="table-section"
              v-for="item in scope.row.chkTxnFile.fileList"
              :key="item.name"
            >
              <div class="table-file table-file-download">
                <span class="table-file-name"> {{ item.name }} </span>
                <el-button
                  plain
                  size="small"
                  type="primary"
                  class="table-file-button"
                  >{{ $t("messages.btnDownload")
                  }}<i class="icon-DownloadSimple"></i
                ></el-button>
              </div>
            </div> -->
          </template>
          <template #crctnResltCmpltYn="{ scope }">
            <el-radio v-model="scope.row.crctnResltCmpltYn" label="Y" :disabled="!isWrite"
              >완료</el-radio
            >
            <el-radio v-model="scope.row.crctnResltCmpltYn" label="N" :disabled="!isWrite"
              >미완료</el-radio
            >
          </template>
          <template #crctnTxn="{ scope }">
            <el-input
              :placeholder="$t('messages.plInput')"
              v-model="scope.row.crctnTxn"
              size="small"
              :disabled="!isWrite"
            >
            </el-input>
          </template>
          <template #chkCrctnFile="{ scope }">
            <div class="border-box ctrt-upload">
              <el-upload 
                :auto-upload="false"
                :on-change="(file, fileList)=>{ 
                              handleChangeFile(file, fileList, scope.$index) 
                            }"
                :show-file-list="false"
                :fileList="scope.row.chkCrctnFile.fileList"
                v-bind="$attrs"
                v-on="$listeners"
                multiple
                action=""
              >
                <el-button type="info" plain size="small" 
                  >{{ $t("messages.btnFile") }}<i class="icon-FileArrowUp"
                /></el-button>
              </el-upload>
              <div>
                <template v-for="file in scope.row.chkCrctnFile.preFileList">
                  <div class="border-box ctrt-upload" :key="file.atcFileSeq">
                    <idc-file-upload :file-list="[file]"
                      :on-remove="removePreFile"
                      :on-preview="downloadFile"
                    ></idc-file-upload>
                    <el-button size="small" type="minus" @click="removePreFile(file,scope.$index)"><i class="icon-Minus"/></el-button>
                  </div>
                </template>
                <template v-for="(file, index) in scope.row.chkCrctnFile.fileList">
                  <div class="border-box ctrt-upload" :key="index">
                    <idc-file-upload 
                      :file-list="[file]"
                      :on-remove="removeCalFile"
                    ></idc-file-upload>
                    <el-button size="small" type="minus" @click="removeCalFile(file,scope.$index)"><i class="icon-Minus"/></el-button>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </idc-list>
      </div>
      <div class="btn-box">
        <el-button type="primary" v-if="isWrite" @click="saveSftyChkCrctnList" :disabled="isTemplate">{{
          $t("messages.btnSave")
        }}</el-button>
      </div>
    </div>
    <el-divider class="wrk-comp-divider" v-if="!toggleData"></el-divider>
    <!-- <IdcNoData v-else-if="tableData.length === 0" text="좌측의 원하는 정보를 선택하시면 상세정보가 노출됩니다."/>  -->
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
import IdcFileUpload from "@/components/common/IdcFileUpload.vue";
import { fileSizeCheck, fileExtCheck, commonFileDownload } from "@/assets/js/common.js";
import FileSaver from "file-saver";
import {  getDateFormatter } from "@/assets/js/common.js";

export default {
  components: { IdcList, IdcFileUpload },
  props: {
    // 
    isConst: {
      type: Boolean,
      default: false,
    },
    openToggle: {
      type: Boolean,
      default: false,
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default : true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    depth1SvcCtlogId: {
      type: String,
      default: "",
    },
    prcssTypeCd: {
      type: Number,
      default: 0
    },
    idcCd: {
      type: String,
      default: "",
    },
    stepCd: {
      type: Number,
      default: 0
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    //상위 공정 ID
    mainPrcssId: { 
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: ''
    },
    scrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn:{
      type: String,
      default: 'N'
    },
    sftyChkMandChkYn: {
      type: String,
      default: 'N'
    },
    sftyChkScrnYn: {
      type: String,
      default: 'N'
    },
    scrnGetApi: {
      type: String,
      default: ''
    },
    scrnPostApi: {
      type: String,
      default: ''
    },
    scrnPutApi: {
      type: String,
      default: ''
    },
    scrnDeleteApi: {
      type: String,
      default: ''
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleData: true,
      toggle: this.openToggle,
      currPrcssTrtDataCnctId: "",
      fileList: [
        {
          name: "file__name_1",
        },
      ],
      tableHeader: [
        {
          prop: "rn",
          label: "NO",
          width: "2",
        },
        {
          prop: "listDivCdHnglNm",
          label: "종류",
          width: "2",
        },
        {
          prop: "sftyChkDay",
          label: "안전점검일",
          columnType: "custom",
          width: "5",
        },
        {
          prop: "sftyChkSbst",
          label: "안전점검내역",
          columnType: "custom",
          width: "5",
        },
        {
          prop: "chkTxnFile",
          label: "안전점검거증",
          columnType: "custom",
          width: "5",
        },
        {
          prop: "crctnResltCmpltYn",
          label: "시정결과",
          columnType: "custom",
          width: "4",
        },
        {
          prop: "crctnTxn",
          label: "시정내역",
          columnType: "custom",
          width: "5",
        },
        {
          prop: "chkCrctnFile",
          label: "시정거증",
          columnType: "custom",
          width: "5",
        },
      ],
      tableData: [],
      chkTableData: []//합동, 순회 시정필요 데이터
    };
  },
  mounted() {
    this.getSafetyCheckInfoList();
  },
  watch:{
    prcssTrtDataCnctId(){
      this.getSafetyCheckInfoList();
    },
  },
  methods: {
    getSafetyCheckInfoList(){
      const list = this.$store.getters["wflowComponentStore/getSafetyCheckInfoList"];
      console.log(list)
      if (list.length > 0) {
        list.forEach(data => {
          console.log(data.prcssTrtDataCnctId)
          this.$BIZ_SERVICE
            .post(data.getApi, {
              prcssTrtDataCnctId: data.prcssTrtDataCnctId,
              chkResltYn : "N"
            })
            .then((res) => {
              if (res.data.resData != null) {
                console.log("결과")
                console.log(res.data.resData)
                // 안전점검내역(순회,합동)
                let wrkSftyChkTxnList = res.data.resData.wrkSftyChkTxnList;
                wrkSftyChkTxnList.map((data)=>{
                  data.chkTxnFile = { preFileList : [], fileList: [] };
                  data.chkTxnFile.preFileList = data.preFileList.filter(i=> i.divText != 'sftyChkCrctnList')
                  data.chkTxnFile.preFileList = data.chkTxnFile.preFileList.map(file=>{
                    return {
                      ...file,
                      name : file.fileLgicName
                    }
                  });
                  data.crctnResltCmpltYn = "N"
                  return data;
                })
                this.chkTableData = this.chkTableData.concat(wrkSftyChkTxnList);
                this.getSftyChkCrctnList();
              }else{
                this.tableData = [];
              }
            })
            .catch((error) => {
              console.log(error);
            })
        })
      }
    } ,
    getSftyChkCrctnList(){
      // if(flag){
        if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
          this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId
        }
        // else{
        //   if(Object.keys(this.defaultValue).length > 0){
        //     this.tableData = this.defaultValue;
        //   }
        //   return;
        // }
      // }
      this.$BIZ_SERVICE
      .post(this.scrnGetApi, { prcssTrtDataCnctId: this.currPrcssTrtDataCnctId })
      .then((res) => {
        if (res.data.resData && res.data.resData.wrkSftyChkCrctnList.length > 0) {
          let wrkSftyChkCrctnList = res.data.resData.wrkSftyChkCrctnList;
          wrkSftyChkCrctnList.map((data)=>{
            data.chkCrctnFile = { preFileList : [], fileList: [] };
            data.chkCrctnFile.preFileList = data.preFileList.filter(i=> i.divText === 'sftyChkCrctnList')
            data.chkCrctnFile.preFileList = data.chkCrctnFile.preFileList.map(file=>{
              return {
                ...file,
                name : file.fileLgicName
              }
            });
            return data;
          })
          this.setList(wrkSftyChkCrctnList, this.chkTableData);
        }else {
          console.log(this.chkTableData)
          this.tableData = this.chkTableData.map((data, i) =>{
            data.chkCrctnFile = { preFileList : [], fileList:[]};
            data.rn = i + 1;
            return data;
          });
          console.log(this.tableData)
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(()=>{
      });
    },
    setList(list, chkList){
      //list : 시정내역
      //chkList : 점검내역
      let resList = [];
      resList = chkList.filter((chk, index, self) =>
        index === self.findIndex((i) => (
          i.sftyChkTxnInntId === chk.sftyChkTxnInntId
        ))
      )
      let duplList = list.filter(x => resList.some(x1=>x.sftyChkTxnInntId === x1.sftyChkTxnInntId))
      let chkArr = resList.filter(x => list.some(x1=>x.sftyChkTxnInntId !== x1.sftyChkTxnInntId))
      this.tableData = this.tableData.concat(duplList,chkArr);

      this.tableData = resList.map((data, i)=>{
        data.sftyChkDay = getDateFormatter(data.sftyChkDay, "YYYY-MM-DD");
        data.chkTxnFile = { preFileList:[] }
        data.chkTxnFile.preFileList = data.preFileList.filter(file=>file.divText !== 'sftyChkCrctnList')
        data.chkTxnFile.preFileList = data.chkTxnFile.preFileList.map(file=>{
          return {
            ...file,
            name : file.fileLgicName
          }
        });
        data.chkCrctnFile = { preFileList:[], fileList:[] }
        data.chkCrctnFile.preFileList = data.preFileList.filter(file=>file.divText === 'sftyChkCrctnList')
        data.chkCrctnFile.preFileList = data.chkCrctnFile.preFileList.map(file=>{
          return {
            ...file,
            name : file.fileLgicName
          }
        });
        data.rn = i + 1;
        return data;
      })
    },
    saveSftyChkCrctnList(){
      if(this.tableData.length == 0){
        alert('안전점검 시정내역이 없습니다.')
        return;
      } 
      if(!confirm('저장하시겠습니까?')) return;
      
      var obj = {};
      obj.wrkSftyChkCrctnList = this.tableData;

      //공정처리아이디생성용
      obj.prcTrtData = {};
      obj.prcTrtData.exeWflowId = this.exeWflowId
      obj.prcTrtData.stepCd = this.stepCd
      obj.prcTrtData.ticktId = this.ticketInfo ? this.ticketInfo.ticktId: ''
      obj.prcTrtData.scrnId = this.scrnId
      obj.prcTrtData.mainPrcssId = this.mainPrcssId
      obj.prcTrtData.subPrcssId = this.subPrcssId
      obj.prcTrtData.prcssTrtDataCnctId = this.ticketInfo ? this.currPrcssTrtDataCnctId: ''
      obj.prcTrtData.wflowScrnId = this.wflowScrnId

      const headers = {"Content-Type" : "multipart/form-data"};
      const fileData = new FormData();
      for (var row of obj.wrkSftyChkCrctnList) {
        if (row.chkCrctnFile.fileList.length > 0) {
          for (var file of row.chkCrctnFile.fileList) {
            fileData.append(row.rn, file.raw);
          }
        }
      }
      fileData.append("wrkSftyCrctnList", JSON.stringify(obj))
      
      this.$BIZ_SERVICE
        .post(this.scrnPostApi, fileData, {headers})
        .then((res) => {
          this.currPrcssTrtDataCnctId = res.data.resData
          alert("등록되었습니다.");
        })
        .catch((error) => {
          console.log(error);
        }).finally(()=>{
          this.getSafetyCheckInfoList();
        });
    },
    chkValidateData() {
      // 공정처리데이터아이디가 있으면 true
      // 단, 목록성 데이터인 경우 로우가 있어야지 true (필수로 있어야하는 데이터라면 체크)
      if(this.mandDataChkYn != 'Y'){
        return true;
      }else {
        if(this.currPrcssTrtDataCnctId != null && this.currPrcssTrtDataCnctId != ''){
          if(this.chkData.length != this.tableData.length) return false; 
          if(this.tableData.length > 0) return true;
        }else{
          if(this.chkData.length == 0) return false;
        }
      }
    },
    handleChangeFile (file, fileList, i) {
      if (fileSizeCheck(file.raw, 100)) {
        if (fileExtCheck(file.raw)) {
          this.tableData[i].chkCrctnFile.fileList = fileList;
        } else {
          alert("파일 확장자를 확인하세요.");
          this.tableData[i].chkCrctnFile.fileList = [];
        }
      } else {
        alert("파일 업로드 최대 사이즈는 100MB 입니다.");
        this.tableData[i].chkCrctnFile.fileList = [];
      }
      if(file.size == 0){
        alert("파일 사이즈가 0KB 인 파일은 업로드할 수 없습니다.");
        this.fileList = [];
      }
    },
    removeCalFile(rFile,idx){
      this.tableData[idx].chkCrctnFile.fileList 
      = this.tableData[idx].chkCrctnFile.fileList.filter(file=>rFile !== file);
      this.fileList = this.fileList.filter(file=>rFile !== file);
    },
    removePreFile(rFile, idx) {
      this.tableData[idx].chkCrctnFile.preFileList 
      = this.tableData[idx].chkCrctnFile.preFileList.filter(file=>rFile.atcFileSeq !== file.atcFileSeq);
    },
    downloadFile(file) {
      commonFileDownload(this.$BIZ_SERVICE, FileSaver, file, this.$API_URLS.Wrk.fileDownloadWrkComnAtcFile);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block;";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 150px;
  }
  .el-table {
    min-width: 1200px;
  }
  .cell {
    display: block;
  }
}
.content {
  overflow-x: auto;
}
.btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.end-btn-box {
  position: absolute;
  bottom: 0px;
  right: 12px;
}
// .ctrt-upload {
//   width: 100%;
//   display: flex;
//   justify-content: space-between;
//   gap: 10px;
//   div {
//     width: 100%;
//   }
// }
// .table {
//   &-section {
//     display: block;
//     padding: 2px 0;
//     &-desc {
//       color: $--text-nodata;
//       font-size: $--font-size-small;
//     }
//   }
//   &-list {
//     display: block;
//     padding: 0;
//     margin-top: -5px;
//     ::v-deep {
//       .el-upload-list__item {
//         margin: 0;
//       }
//     }
//   }

  // &-file {
  //   display: flex;
  //   justify-content: space-between;
  //   width: 100%;
  //   &-name {
  //     line-height: 30px;
  //     text-overflow: ellipsis;
  //     width: auto;
  //     display: inline-block;
  //     overflow: hidden;
  //     white-space: nowrap;
  //     flex: 0 0 calc(100% - 90px);
  //   }
  //   &-button {
  //   }
  //   &-download {
  //   }
  // }
// }
.border-box {
  padding: 5px 5px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1px solid $--color-light-gray;
}
</style>
